const {
  evaluateSource,
  updateTransientContext
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate arrayMapBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const transientContextMap = await evaluateSource(source.contextMap || source.transientContextMap, content, parentContentPath, transientContext, nativeFunctions);
  const result = [];
  let index;
  for (index = 0; index < values.length; index += 1) {
    const value = values[index];
    const childTransientContext = JSON.parse(JSON.stringify(transientContext));
    updateTransientContext(childTransientContext, transientContextMap, {
      index,
      value,
      values
    });
    // eslint-disable-next-line no-await-in-loop
    result.push(await evaluateSource(source.valueTransform, content, parentContentPath, childTransientContext, nativeFunctions));
  }
  return result;
};
module.exports = {
  evaluate
};